(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-variant-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pups-size-options')) {
    customElements.define(
      'pups-size-options',
      class PupsSizeOptions extends HTMLElement {
        connectedCallback() {
          this.select = document.getElementById(this.dataset.selectId);
          if (!(this.select instanceof HTMLSelectElement)) return;

          this.handleClick = (event) => {
            const button = event.target.closest('[data-pups-size-choice]');
            if (!button || button.disabled) return;

            this.select.value = button.dataset.value;
            this.select.dispatchEvent(new Event('change', { bubbles: true }));
          };
          this.handleChange = () => this.sync();

          this.addEventListener('click', this.handleClick);
          this.select.addEventListener('change', this.handleChange);
          this.observer = new MutationObserver(() => this.sync());
          this.observer.observe(this.select, {
            attributes: true,
            subtree: true,
            attributeFilter: ['selected'],
          });

          this.sync();
          requestAnimationFrame(() => this.sync());
        }

        disconnectedCallback() {
          this.removeEventListener('click', this.handleClick);
          this.select?.removeEventListener('change', this.handleChange);
          this.observer?.disconnect();
        }

        sync() {
          if (!this.select) return;

          const selectedValue = this.select.selectedIndex >= 0 ? this.select.value : '';
          const selectedLabel = this.querySelector('[data-pups-size-selected]');
          if (selectedLabel) selectedLabel.textContent = selectedValue || '\u2014';

          this.querySelectorAll('[data-pups-size-choice]').forEach((button) => {
            const isSelected = selectedValue !== '' && button.dataset.value === selectedValue;
            button.classList.toggle('is-selected', isSelected);
            button.setAttribute('aria-pressed', String(isSelected));
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pups-pack-color-family"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', (event) => {
    if (!event.target.matches('variant-selects input[name^="Size-"], variant-selects select[name="options[Size]"]')) return;

    const picker = event.target.closest('variant-selects');
    if (!picker) return;

    const sizeKey = event.target.value.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    picker.querySelectorAll('[data-sibling-color]').forEach((link) => {
      const nextUrl = link.dataset[`size${sizeKey.charAt(0).toUpperCase()}${sizeKey.slice(1)}`];
      if (nextUrl) link.href = nextUrl;
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pups-pack-product-share"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-share-control')) {
    customElements.define(
      'product-share-control',
      class ProductShareControl extends HTMLElement {
        connectedCallback() {
          this.button = this.querySelector('button');
          this.status = this.querySelector('[role="status"]');
          this.button.addEventListener('click', this.share.bind(this));
        }

        async share() {
          const shareData = {
            title: this.dataset.shareTitle,
            url: this.dataset.shareUrl,
          };

          if (navigator.share) {
            try {
              await navigator.share(shareData);
            } catch (error) {
              if (error.name !== 'AbortError') {
                await this.copyLink();
              }
            }
            return;
          }

          await this.copyLink();
        }

        async copyLink() {
          await navigator.clipboard.writeText(this.dataset.shareUrl);
          this.status.textContent = window.accessibilityStrings.shareSuccess;
          window.setTimeout(() => {
            this.status.textContent = '';
          }, 2500);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
